import { render, staticRenderFns } from "./PurchasePayment.vue?vue&type=template&id=12887b5b&scoped=true"
import script from "./PurchasePayment.vue?vue&type=script&lang=js"
export * from "./PurchasePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12887b5b",
  null
  
)

export default component.exports